<template>
  <div class="switch-tabs-wrapper">
    <div class="switch-tabs">
      <div
        class="switch-tabs-item"
        v-for="item in options"
        :key="item.value"
        :class="{ active: value === item.value, disabled: !!item.disabled }"
        @click="change(item)"
      >
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    options: { type: Array, default: () => [] },
  },
  methods: {
    change({ value, disabled } = {}) {
      if (disabled) return

      this.$emit('update:value', value)
      this.$emit('input', value)
      this.$emit('change', value)
    },
  },
}
</script>
<style lang="scss" scoped>
.switch-tabs-wrapper {
  .switch-tabs {
    display: flex;
    align-items: center;
    gap: 40px;

    .switch-tabs-item {
      cursor: pointer;
      width: max-content;
      font-size: 14px;
      padding: 20px 0 17px;
      color: #303133;
      border-bottom: 3px solid transparent;
    }

    .switch-tabs-item.active,
    .switch-tabs-item:hover {
      color: #007bff;
      font-weight: bold;
      border-bottom-color: #007bff;
    }

    .switch-tabs-item.disabled {
      cursor: not-allowed;
      color: #2e2e2e;
      border-bottom: 3px solid transparent;
    }
  }
}
</style>
